{
    "ALERT": {
        "ERROR": {
            "MESSAGE": {
                "NOT_FOUND": "Le fichier est introuvable"
            },
            "TITLE": "Erreur"
        },
        "SUCCESS": {
            "MESSAGE": {
                "CREATE": "Création effectuée avec succès",
                "EDIT": "Modification effectuée avec succès",
                "DELETE": "Suppression effectuée avec succès",
                "REFUND": "Remboursement effectué avec succès",
                "SEND_RESET_PIN": "Le courriel à été envoyé avec succès",
                "STATUS_CHANGED": "Changement de statut effectué avec succès",
                "UPLOAD": "Téléversement complété avec succès",
                "DELETE_SUBSCRIPTION": "L’abonnement a bien été supprimé"
            },
            "TITLE": "Succès"
        }
    },
    "BUTTON": {
        "NO": "Non",
        "YES": "Oui",
        "DETAIL": "Détail",
        "DELETE": "Supprimer",
        "EDIT": "Modifier",
        "SAVE": "Enregistrer",
        "CANCEL": "Annuler",
        "CANCEL_SUBSCRIPTION": "Annuler l'abonnement",
        "LOCATE": "Réinitialiser le marqeur",
        "ADD_CAR": "Ajouter une voiture",
        "ADD_TERMINAL": "Ajouter une borne",
        "ADD_LINK": "Ajouter un lien",
        "ADD_PERIOD": "Ajouter un horaire",
        "CREATE_STATION": "Créer une station",
        "ADD": "Ajouter",
        "CREATE": "Créer",
        "VIEW_REAL_TIME": "Voir en temps réel",
        "ADD_IMAGE": "Ajouter une image",
        "DELETE_IMAGE": "Supprimer une image",
        "SHOW_SUBSCRIPTION": "Afficher les abonnements actifs"
    },
    "COLUMNS": {
        "DETAILS": "Détails",
        "CONNECTOR_ID": "ID du connecteur",
        "CITY": "Ville",
        "STREET": "Rue",
        "TERMINALS": "Bornes",
        "FIRST_NAME": "Prénom",
        "LAST_NAME": "Nom",
        "NAME": "Nom",
        "EMAIL": "Courriel",
        "PHONE_NUMBER": "Numéro de téléphone",
        "STATUS": "Statut",
        "LEVEL": "Niveau",
        "BREAKER": "Disjoncteur",
        "NUMBER": "Nb. de bornes",
        "COST": "Coût",
        "VOLTAGE": "Voltage",
        "AMPERAGE": "Amperage",
        "ACCESS": "Accès",
        "TERMINAL_NAME": "Nom de la borne",
        "DAY_OF_THE_WEEK": "Jour de la semaine",
        "PERCENTAGE": "Pourcentage",
        "TOTAL_CHARGE": "Charge totale",
        "STATION_NAME": "Nom de la station",
        "STATE_OF_CHARGE": "État de la charge",
        "SESSION_DURATION": "Durée de la session",
        "ENERGY_CONSUMED": "Énergie consommée",
        "TOTAL": "Total $",
        "BARCODE": "Code barre",
        "START_DATE": "Date de début",
        "END_DATE": "Date de fin",
        "VISIBLE": "Visible",
        "SUBSCRIPTION": "Abonnement",
        "IS_ACTIVE": "Activé",
        "NOT_ACTIVE": "Non activé",
        "POWER": "Puissance",
        "SERIAL_NUMBER": "Numéro de série",
        "ACCESS_MODE": "Mode d'accès",
        "ACCESS_TYPE": "Type d'accès",
        "ESTIMATED_COST": "Coût estimé d'electricité (¢)",
        "FIRMWARE_VERSION": "Version du micrologiciel",
        "MAC_ADDRESS": "Addresse MAC",
        "WIFI_RSSI": "RSSI WiFi",
        "LOCAL_IP_ADDRESS": "Addresse IP Locale",
        "MINIMUM_SESSION_DURATION": "Durée de session minimum",
        "DEFAULT_SESSION_DURATION": "Durée de session par défaut",
        "MAXIMUM_SESSION_DURATION": "Durée de session maximum",
        "RESTART": "Redémarrer",
        "REFRESH": "Rafraîchir",
        "VALUE": "Valeur",
        "DAYS": "Jours",
        "HOURS": "Heures",
        "SET": "Set"
    },
    "DIALOG": {
        "CHANGE_PASSWORD": {
            "TITLE": "Changer votre mot de passe"
        },
        "CONFIRM_ACTION": {
            "TITLE": "Confirmation",
            "MESSAGE": "Êtes-vous sûr de vouloir exécuter cette action?"
        },
        "CONFIRM_BONUS_EXPIRATION_DATE": {
            "TITLE": "Confirmation de la date d'expiration de la bonification",
            "MESSAGE": "Cette action va changer la date de garantie pour: {{bonusDate}} ? "
        },
        "DISABLE": {
            "TITLE": "Désactiver un élément",
            "MESSAGE": "Voulez-vous vraiment désactiver cet élément?"
        },
        "LOGO": {
            "TITLE": "Téléverser un logo"
        },
        "UNSAVED_CHANGES": {
            "TITLE": "Changements non enregistrés",
            "MESSAGE": "Vous avez des changements non enregistrés. Êtes-vous sûr de vouloir les annuler?"
        }
    },
    "FEEDBACK": {
        "MESSAGE": {
            "ERROR": {
                "403": "Vous n'avez pas l'autorisation de visionner cette page",
                "404": "Page non trouvée",
                "500": "Erreur interne au serveur",
                "AN_ERROR_OCCURRED": "Une erreur est à nouveau survenue, réessayez plus tard",
                "CARD_ALREADY_USE": "Cette carte est déjà utilisée.",
                "CARD_WAITING": "La carte est en attente d'activation par le client.",
                "CREATE": "Une erreur est survenue lors de la création de l'élément.",
                "DISABLE": "Une erreur est survenue lors de la désactivation de l'élément.",
                "EDIT": "Une erreur est survenue lors de la modification de l'élément.",
                "EMPTY_LIST": "La liste de {{type}} est vide",
                "NOT_FOUND": "{{field}} non trouvé",
                "NOT_SET": "{{field}} non défini"
            },
            "IMAGE_SIZE": "Le format de l'image ({{width}}x{{height}}) n'est pas optimal",
            "SUCCESS": {
                "CREATE": "Élément créé avec succès",
                "DISABLE": "Élément désactivé avec succès",
                "EDIT": "Élément modifié avec succès",
                "UPLOAD": "Votre image a été téléversée avec succès"
            }
        },
        "VALIDATION": {
            "ERROR": {
                "104": "L'utilisateur ou le mot de passe est invalide",
                "IMAGE_SIZE": "Le format de l'image ({{width}}x{{height}}) est invalide",
                "PASSWORD_MATCH": "Les mots de passe ne correspondent pas",
                "PATTERN": "{{field}} est invalide",
                "REQUIRED": "{{field}} est requis",
                "NOT_NUMBER": "{{field}} n'est pas un chiffre",
                "TYPE": "Le type est requis",
                "IMAGE": {
                    "UPLOAD": "Une erreur est survenue lors du téléversement de l'image {{error}}"
                }
            }
        }
    },
    "FIELD": {
        "BARCODE": {
            "TITLE": "Code-barre"
        },
        "CATEGORY": {
            "TITLE": "Catégorie"
        },
        "EMAIL": {
            "TITLE": "Courriel ou Numéro de téléphone",
            "PLACEHOLDER": "Courriel ou Numéro de téléphone",
            "NOTIFICATION": {
                "TITLE": "Notification de courriel"
            }
        },
        "DATE": {
            "START": {
                "TITLE": "Date de début"
            },
            "END": {
                "TITLE": "Date de fin"
            }
        },
        "ID": {
            "TITLE": "Id"
        },
        "INFOS": {
            "TITLE": "Infos"
        },
        "NAME": {
            "TITLE": "Nom"
        },
        "STATION": {
            "TITLE": "Station"
        },
        "STATIONS": {
            "TITLE": "Stations"
        },
        "VISIBLE": {
            "TITLE": "Est visible"
        },
        "WEBSITE": {
            "TITLE": "Site web"
        },
        "PHONE_NUMBER": {
            "TITLE": "Numéro de téléphone"
        }
    },
    "HEADER": {
        "LOGOUT": "Déconnexion",
        "PROFILE": "Profil",
        "TOGGLE_MENU": "Menu"
    },
    "LABEL": {
        "ADDRESS": "Adresse",
        "FIRST_NAME": "Prénom",
        "LAST_NAME": "Nom",
        "EMAIL": "Courriel",
        "NAME": "Nom",
        "COLOR": "Couleur",
        "YEAR": "Année",
        "PHONE_NUMBER": "Numéro de téléphone",
        "POSTAL_CODE": "Code postal",
        "COUNTRY": "Pays",
        "BALANCE": "Balance",
        "STREET": "Rue",
        "CITY": "Ville",
        "STATE": "Province",
        "STATUS": "Statut",
        "SUITE": "Suite",
        "CHARGE_BOX_IDENTITY": "Identité de la borne",
        "COST": "Coût",
        "TIME_IN_MINUTES": "Temps en minutes",
        "VOLTAGE": "Voltage",
        "AMPERAGE": "Amperage",
        "ADD_CONNECTOR": "Ajouter un connecteur",
        "LEVEL": "Niveau",
        "LANGUAGE": "Langue",
        "ID": "Id",
        "VISIBLE": "Visible",
        "INFOS": "Infos",
        "START_DATE": "Date de début",
        "END_DATE": "Date de fin",
        "SUBSCRIPTION": "Abonnement",
        "IMAGE_UPLOADER": "Image de la station"
    },
    "LOGIN": {
        "TITLE": "Connexion",
        "SIGN_IN": "Connexion",
        "PASSWORD": {
            "TITLE": "Mot de passe",
            "PLACEHOLDER": "********"
        },
        "FORGOT_PASSWORD": "Oublié votre mot de passe?"
    },
    "PLACEHOLDERS": {
        "SEARCH": "Recherche"
    },
    "HOME": {
        "TITLE": "Accueil"
    },
    "REPORTS": {
        "TITLE": "Rapports",
        "SESSION_HISTORY": {
            "TITLE": "Historique des sessions"
        }
    },
    "STATIONS": {
        "DETAIL": {
            "TERMINALS_LIST": "Liste des bornes",
            "LINKS_LIST": "Liste des liens",
            "PERIODS_LIST": "Liste des horaires",
            "TITLE": "Détails de la station"
        },
        "CREATE": {
            "TITLE": "Créer une station",
            "CREATE": "Créer"
        },
        "EDIT": {
            "TITLE": "Modifier la station",
            "EDIT": "Modifier"
        },
        "LIST": {
            "TITLE": "Liste des stations"
        },
        "TERMINAL": {
            "CREATE": {
                "TITLE": "Créer une borne"
            },
            "EDIT": {
                "TITLE": "Modifier la borne"
            }
        },
        "TITLE": "Stations"
    },
    "USERS": {
        "DETAIL": {
            "CARS_LIST": "Liste des voitures",
            "TITLE": "Détails de l'utilisateur"
        },
        "EDIT":{
            "TITLE": "Modifier l'utilisateur",
            "EDIT": "Modifier"
        },
        "LIST": {
            "TITLE": "Liste des utilisateurs"
        },
        "TITLE": "Utilisateurs"
    },
    "SETTINGS": {
        "TITLE": "Configuration"
    },
    "LINKS": {
        "LINK":"Liaison",
        "LEVEL":"Niveau",
        "BREAKER":"Disjoncteur"
    },
    "COMMON": {
        "EDIT": "Modifier",
        "LANGUAGE": "Langue",
        "CREATE": "Créer"
    },
    "ADD_IMAGE": {
        "DESCRIPTION": "Choisissez un fichier PNG/JPEG contenant un minimum de {{minWidth}} pixels de largeur et {{minHeight}} pixels de hauteur.",
        "FORMAT_INVALID": "Le format de l'image est invalide",
        "TITLE": "Téléverser une image",
        "SIZE_ERROR": "Le format de l'image ({{width}}x{{height}}) est invalide"
    },
    "REPORT":
    {
        "MONTH": "Mois",
        "FORMAT": "Format du Rapport",
        "DOWNLOAD_PDF": "Télécharger comme PDF",
        "DOWNLOAD_CSV": "Télécharger comme CSV"
    },
    "STATUS":
    {
        "AVAILABLE": "Disponible",
        "IN_USE": "En cours d'utilisation",
        "PENDING": "En attente de connexion",
        "OUT_OF_SERVICE": "Hors service",
        "UNKNOWN": "Non-connecté"
    },
    "GRID_PAGER":
    {
        "ITEMS":"items",
        "OF":"de"
    },
    "AUTOCOMPLETE":
    {
        "PLACEHOLDER":"Position"
    },
    "IMAGE_UPLOADER":
    {
        "NO_IMAGE":"Téléverser une image"
    },
    "SCHEDULE_PERIOD":
    {
        "TYPE":
        {
            "ACCESS":"Accès",
            "STATUS":"Statut",
            "POWER_LIMITATION":"Limite de Puissance",
            "COST":"Tarification"
        },
        "PUBLIC":"Publique",
        "PRIVATE":"Privée",
        "OUT_OF_SERVICE":"Hors Service"
    },
    "WEEKDAYS":
    {
        "MONDAY":"Lundi",
        "TUESDAY":"Mardi",
        "WEDNESDAY":"Mercredi",
        "THURSDAY":"Jeudi",
        "FRIDAY":"Vendredi",
        "SATURDAY":"Samedi",
        "SUNDAY":"Dimanche"
    },
    "INVITATION":
    {
        "OWNERSHIP_TRANSFER":"Transfert de propriété : ",
        "ERROR":"erreur",
        "COMPLETED":"complété",
        "ERROR_LABEL":"L’erreur suivante est survenue : ",
        "CLOSE_WEBPAGE":"Vous pouvez fermer cette page web.",
        "DESCRIPTION_1":" désire vous céder la propriété de la station ",
        "DESCRIPTION_2":" située au ",
        "DESCRIPTION_3":", ainsi que les bornes qu’elle contient.",
        "DELETE_GUESTS":"Supprimer les invités actuellement présents dans cette station",
        "KEEP_CURRENT_OWNER_ACCESS":"Conserver le propriétaire actuel comme invité de la station",
        "ACCOUNT_INSTRUCTIONS_1":"Au moins une des bornes contenues dans cette station est de type Payante.",
        "ACCOUNT_INSTRUCTIONS_2":"Pour compléter le transfert de propriété de cette station, un compte de versement valide doit être ajouté dans votre compte EVduty.",
        "ACCOUNT_INSTRUCTIONS_3":"Pour ajouter un compte de versement dans votre compte EVduty :",
        "ACCOUNT_INSTRUCTIONS_4":"application mobile EVduty → Profil → Versements",
        "ACCOUNT_INSTRUCTIONS_5":"Une fois que le compte de versement aura été ajouté, le transfert de propriété pourra être complété.",
        "ACCEPT":"Accepter",
        "DECLINE":"Refuser",
        "DECLINED":"invitation refusée",
        "DECLINED_DESCRIPTION_1":"Vous avez ",
        "DECLINED_DESCRIPTION_2":"refusé",
        "DECLINED_DESCRIPTION_3":" la demande de transfert de propriété de la station ",
        "DECLINED_DESCRIPTION_4":" envoyée par ",
        "DECLINED_DESCRIPTION_5":"Nous en informerons l’actuel propriétaire.",
        "COMPLETED_DESCRIPTION_1":"Vous avez accepté la demande de transfert de propriété de la station ",
        "COMPLETED_DESCRIPTION_2":" envoyée par ",
        "COMPLETED_DESCRIPTION_3":"Le transfert a été effectué avec ",
        "COMPLETED_DESCRIPTION_4":"succès",
        "COMPLETED_DESCRIPTION_5":"Vous pouvez dès maintenant accéder à cette station depuis ",
        "COMPLETED_DESCRIPTION_6":"l’application mobile EVduty",
        "COMPLETED_DESCRIPTION_7":" dans l’onglet ",
        "COMPLETED_DESCRIPTION_8":"Mes Bornes",
        "COMPLETED_DESCRIPTION_9":"."
    },
    "SCHEDULES":
    {
        "SCHEDULE":"Horaire",
        "START_TIME":"Temps de début",
        "END_TIME":"Temps de fin",
        "DAYS":"Jours",
        "LINKED_TERMINALS":"Bornes liées à cet horaire",
        "ACCESS_TYPE":"Type d'horaire",
        "OUT_OF_SERVICE":"Hors Service",
        "PUBLIC":"Publique",
        "POWER_TYPE":"Type de limite",
        "TIME":"Temps",
        "ALTERNATE_COST":"Coût Alternatif",
        "DELAY":"Délai"
    },
    "POWER_TYPE":
    {
        "AMPERES":"Ampères",
        "WATTS":"Watts"
    },
    "FOR":"pour",
    "AFTER":"après",
    "TO":"à",
    "FREE":"Gratuit"
}
